import { useId } from 'react'
import {
  renderPageBody,
  pageStyles,
  getTheme,
  getFont,
  googleFontHref,
  type PublicPage,
} from '@makerstack/page-render'
import { PUBLIC_ORIGIN } from '../../lib/config'

function phonePreviewStyles(scope: string): string {
  return `
${scope} .ms-container{max-width:560px;min-height:0;margin:0 auto;padding:48px 20px 80px;display:block}
${scope} .ms-profile{display:flex;grid-column:auto;position:static;top:auto;flex-direction:column;align-items:flex-start;gap:14px}
${scope} .ms-avatar{width:72px;height:72px}
${scope} .ms-name{font-size:24px;letter-spacing:normal}
${scope} .ms-bio{font-size:16px;max-width:none}
${scope} .ms-subscribe{max-width:none}
${scope} .ms-startups{display:flex;grid-column:auto;flex-direction:column;gap:12px;margin-top:34px}
${scope} .ms-card{padding:16px;border-radius:14px}
${scope} .ms-card-icon{width:40px;height:40px}
${scope} .ms-footer{grid-column:auto;margin-top:44px}
`.trim()
}

/**
 * Renders a maker page using the same pure render module as the SSR route.
 * Phone mode explicitly holds the mobile layout regardless of browser width;
 * all CSS remains scoped so it never leaks into the app chrome.
 */
export function PagePreview({ page, phone = false }: { page: PublicPage; phone?: boolean }) {
  const rawId = useId().replace(/[^a-zA-Z0-9_-]/g, '')
  const scope = `mspv-${rawId}`
  const theme = getTheme(page.theme)
  const font = getFont(page.font)
  const previewScope = `.${scope}`
  const baseCss = pageStyles(theme, font, previewScope)
  const css = phone ? `${baseCss}\n${phonePreviewStyles(previewScope)}` : baseCss
  const fontHref = googleFontHref(font)
  const body = renderPageBody(page, { origin: PUBLIC_ORIGIN, preview: true })

  return (
    <>
      {fontHref && <link rel="stylesheet" href={fontHref} />}
      <style>{css}</style>
      <div className={`${scope} h-full overflow-y-auto`}>
        <div className="ms-root" dangerouslySetInnerHTML={{ __html: body }} />
      </div>
    </>
  )
}
